<template>
    <div>
        <div>
                <div class="flex flex-wrap justify-between items-center mb-4">
                  <h4 class="font-bold">{{dateRange==1 || dateRange==null? 'Today' : 'This Week'}}</h4>
                  <vs-button icon="event" @click="fetchLessons()">{{dateRange==1  || dateRange==null?'This Week': 'Today'}}</vs-button>
                </div>
                <div
                  style="max-height: 261px; overflow: auto"
                  class="vertical_scrollbar"
                  @scroll="detectsScrollLength()"
                  ref="element"
                >
                  <div
                    class="
                      flex flex-wrap
                      justify-between
                      items-center
                      light_blue_holder
                      p-4
                      mt-2
                    "
                    v-for="(eachData, index) in lessons"
                    :key="index"
                  >
                    <div>
                      <div class="inline-flex items-center">
                        <h5 style="max-width: 300px" class="one_line_truncate">
                          {{ eachData.course.name }}
                        </h5>
                        <span class="cstm-status-badge paid">{{
                          getCourseTypeName(eachData.course.course_class_type)
                        }}</span>
                        <span>{{eachData.schedule_date| moment('ddd, D/MM/YYYY')}}</span>
                      </div>
                      <p class="text-muted">
                        Teacher Name:
                        <span>{{ getTeacher(eachData.course.tutors) }}</span>
                      </p>
                    </div>
                    <div class="inline-flex">
                      <span class="material-icons-outlined pr-2">schedule</span>
                      <span>{{ eachData.schedule_from_time.slice(0, -3) }} - {{ eachData.schedule_to_time.slice(0, -3) }}</span>
                    </div>
                  </div>
                </div>
              </div>
    </div>
</template>
<script>
import { fetchLessons} from '@/api/dashboard.js'
export default {
  data () {
    return {
      customer_id:localStorage.getItem('customer_id'),
      lessons:[],
      dateRange:null,
      meta: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      course_class_type_list: [
        {
          value:'self_based',
          name:'Self Paced Course'
        },
        {
          value:'online_one_2_one',
          name:'Online Individual Course'
        },
        {
          value:'online_one_2_many',
          name:'Online Group Course'
        },
        {
          value:'offline_one_2_one',
          name:'In Person Individual Course'
        },
        {
          value:'offline_one_2_many',
          name:'In Person Group Course'
        }
      ]
    }
  },
  mounted () {
    this.fetchLessons(1)
  },
  methods: {
    getCourseTypeName (type) {
      const getType = this.course_class_type_list.filter((ele) => {
        return ele.value.includes(type)
      })
      if (getType.length) return getType[0].name
      return ''
    },
    detectsScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight && this.meta.has_next
      ) {
        this.loadMoreLessons()
      }
    },
    async loadMoreLessons () {
      const payload = {
        dateRange: this.dateRange === null ? 1 : this.dateRange
      }
      this.meta.current_page = this.meta.current_page + 1
      const {data } = await fetchLessons(this.customer_id, payload, this.meta)
      this.lessons.push(...data.data.schedules)
      this.meta = data.data.meta
    },
    async fetchLessons () {
      //1= today, 2 = week, 3 = month, 4 year
      const payload = {
        dateRange: this.dateRange === null ? 1 : this.dateRange === 1 ? 2 : 1
      }
      this.dateRange = payload.dateRange
      const {data } = await fetchLessons(this.customer_id, payload, this.meta)
      this.lessons = data.data.schedules
      this.meta = data.data.meta
    },
    getTeacher (teachers) {
      const tutors = teachers.map((teacher) => {
        return (`${teacher.first_name  } ${  teacher.last_name}`)
      })
      return tutors.join(', ')
    }
  }
 
}
</script>